export function enumToDropdownOptions(
  e: object
): Array<{ label: string; value: number }> {
  return Object.keys(e)
    .filter((key) => !isNaN(Number(key)))
    .map((key) => ({ label: (e as any)[key], value: Number(key) }));
}
